var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "redirect-connexion-full-screen-modal",
      attrs: {
        id: "redirect-connexion-modal",
        centered: "",
        "no-close-on-esc": "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleOk },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "redirect-connexion-header-content w-100" },
                [
                  _c("div", {
                    staticClass: "redirect-connexion-bg-veilleur h-75"
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "redirect-connexion-step-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-perso-ok.png")
                    }
                  })
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("redirect.connexion.btn")))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.username))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "redirect-connexion-text mt-2",
            domProps: { innerHTML: _vm._s(_vm.$t("redirect.connexion.text")) }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10cad91d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10cad91d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/RedirectConnexionModal.vue
// module id = +rsf
// module chunks = 0